import { Routes } from '@angular/router';
import { AnalysisDashboardPage } from './pages/analysis-dashboard-page/analysis-dashboard-page';
import { AnalysisLmaPreviewPage } from './pages/analysis-lma-preview-page/analysis-lma-preview-page';
import { AnalysisConsumptionPage } from './pages/analysis-consumption-page/analysis-consumption-page';
import {
  consumptionDashboardLoadedGuard,
  consumptionLoadedGuard,
} from './guards/consumption-loaded.guard';
import { AnalysisPricePage } from './pages/analysis-price-page/analysis-price-page';

import { priceLoadedGuard } from './guards/price-loaded.guard';
import { videoTutorialsLoadedGuard } from '../tutorials/guards/video-tutorials-loaded.guard';

export const ANALYSIS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AnalysisDashboardPage,
    canActivate: [consumptionDashboardLoadedGuard, videoTutorialsLoadedGuard],
  },
  {
    path: 'consumption',
    component: AnalysisConsumptionPage,
    canActivate: [consumptionLoadedGuard],
  },
  {
    path: 'price',
    component: AnalysisPricePage,
    canActivate: [priceLoadedGuard],
  },
  {
    path: 'lma/:documentId',
    component: AnalysisLmaPreviewPage,
  },
];
